module.exports = __webpack_public_path__ + "img/file-download-outline.b695ffd0.svg";